


export const MANAGE_EMPLOYEE = 'manageEmpolyee';
export const GET_MANAGE_EMPLOYEE = `${MANAGE_EMPLOYEE}/getManageEmployeesAction`;
export const SET_MANAGE_EMPLOYEE = `${MANAGE_EMPLOYEE}/setManageEmployeeAction`;
export const UPDATE_MANAGE_EMPLOYEE = `${MANAGE_EMPLOYEE}/updateManageEmployeeAction`;
export const SET_MANAGE_EMPLOYEE_CYCLE_DROPDOWN = `${MANAGE_EMPLOYEE}/setDropDownAction`;
export const SET_MANAGE_EMPLOYEE_UPDATE_STATUS = `${MANAGE_EMPLOYEE}/setUpdateStatusAction`;
export const SET_MANAGE_EMPLOYEE_UPDATE_MANAGER = `${MANAGE_EMPLOYEE}/setUpdateManagerAction`;
export const ADMIN_RESET_ASSESSMENT = `${MANAGE_EMPLOYEE}/adminResetAssessmentAction`;

